/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSalesforceCaseMutationVariables = Types.Exact<{
  createSalesforceCaseInput?: Types.InputMaybe<Types.CreateSalesforceCaseInput>;
}>;


export type CreateSalesforceCaseMutation = { __typename?: 'Mutation', createSalesforceCase?: { __typename?: 'Case', id: string } | null };


export const CreateSalesforceCaseDocument = gql`
    mutation CreateSalesforceCase($createSalesforceCaseInput: CreateSalesforceCaseInput) {
  createSalesforceCase(input: $createSalesforceCaseInput) {
    id
  }
}
    `;
export type CreateSalesforceCaseMutationFn = Apollo.MutationFunction<CreateSalesforceCaseMutation, CreateSalesforceCaseMutationVariables>;

/**
 * __useCreateSalesforceCaseMutation__
 *
 * To run a mutation, you first call `useCreateSalesforceCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesforceCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesforceCaseMutation, { data, loading, error }] = useCreateSalesforceCaseMutation({
 *   variables: {
 *      createSalesforceCaseInput: // value for 'createSalesforceCaseInput'
 *   },
 * });
 */
export function useCreateSalesforceCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesforceCaseMutation, CreateSalesforceCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesforceCaseMutation, CreateSalesforceCaseMutationVariables>(CreateSalesforceCaseDocument, options);
      }
export type CreateSalesforceCaseMutationHookResult = ReturnType<typeof useCreateSalesforceCaseMutation>;
export type CreateSalesforceCaseMutationResult = Apollo.MutationResult<CreateSalesforceCaseMutation>;
export type CreateSalesforceCaseMutationOptions = Apollo.BaseMutationOptions<CreateSalesforceCaseMutation, CreateSalesforceCaseMutationVariables>;